import { createMachine } from 'xstate'

interface Props {
  initial: string
}

export const loginOrSignupMachine = ({ initial = 'continueWithEmailOrGmail' }: Props) =>
  createMachine({
    id: 'loginOrSignup',
    initial: initial,
    states: {
      explanation: {
        on: {
          GO_BACK: 'companyData',
          GO_BACK_PLAN: 'plan',
          NEXT: 'blazeStartFreeTrial',
        },
      },
      plan: {
        on: {
          GO_BACK: 'companyData',
          NEXT_EXPLANATION: 'explanation',
          NEXT_TRIAL: 'blazeStartFreeTrial',
        },
      },
      continueWithEmailOrGmail: {
        on: {
          USING_GMAIL: 'usingGmail',
          USING_EMAIL_AND_PASSWORD: 'usingEmailAndPassword',
          USING_SAML_SSO: 'usingSamlSso',
          VERIFY_EMAIL: 'emailVerification',
          RESET_PASSWORD: 'resetPassword',
        },
      },
      usingEmailAndPassword: {
        on: {
          USER_FOUND: 'enterPassword',
          USER_NOT_FOUND: 'checkEmailOrEnterVerificationCode',
        },
      },
      usingGmail: {
        on: {
          CREATE_WORKSPACE: 'createWorkspace',
          ON_ERROR: 'continueWithEmailOrGmail',
          COMPANY_DATA: 'companyData',
        },
      },
      usingSamlSso: {
        on: {
          GO_BACK: 'continueWithEmailOrGmail',
        },
      },
      enterPassword: {
        on: {
          CREATE_WORKSPACE: 'createWorkspace',
          RESET_PASSWORD: 'checkYourInboxForPasswordResetEmail',
          GO_BACK: 'continueWithEmailOrGmail',
          SELECT_ROLE: 'companyData',
          COMPANY_DATA: 'companyData',
        },
      },
      resetPassword: {
        on: {
          CREATE_WORKSPACE: 'createWorkspace',
          GO_BACK: 'continueWithEmailOrGmail',
          COMPANY_DATA: 'companyData',
        },
      },
      checkYourInboxForPasswordResetEmail: {
        on: {
          GO_BACK: 'continueWithEmailOrGmail',
          COMPANY_DATA: 'companyData',
        },
      },
      checkEmailOrEnterVerificationCode: {
        on: {
          GO_BACK: 'continueWithEmailOrGmail',
          CREATE_ACCOUNT: 'createAccount',
          COMPANY_DATA: 'companyData',
        },
      },
      emailVerification: {
        on: {
          CREATE_ACCOUNT: 'createAccount',
          GO_BACK: 'continueWithEmailOrGmail',
          COMPANY_DATA: 'companyData',
        },
      },
      createAccount: {
        on: {
          GO_BACK: 'continueWithEmailOrGmail',
          CREATE_WORKSPACE: 'createWorkspace',
          COMPANY_DATA: 'companyData',
        },
      },
      createWorkspace: {
        on: {
          COMPANY_DATA: 'companyData',
          START_OVER: 'continueWithEmailOrGmail',
        },
      },
      companyData: {
        on: {
          GO_BACK: 'blazeStartFreeTrial',
          CREATE_WORKSPACE: 'createWorkspace',
          SCHEDULE_DEMO: 'scheduleDemo',
          BLAZE_START_FREE_TRIAL: 'blazeStartFreeTrial',
          EXPLANATION: 'explanation',
          PLAN: 'plan',
        },
      },
      blazeStartFreeTrial: {
        on: {
          CREATE_ACCOUNT: 'createAccount',
          BLAZE_FREE_TRIAL_STARTED: 'blazeFreeTrialStarted',
          GO_BACK: 'createAccount',
          GO_BACK_PLAN: 'plan',
          COMPANY_DATA: 'companyData',
        },
      },
      scheduleDemoLoader: {
        on: {
          SCHEDULE_DEMO: 'scheduleDemo',
          DEMO_SCHEDULED: 'demoScheduled',
        },
      },
      scheduleDemo: {
        on: {
          DEMO_SCHEDULED: 'demoScheduled',
          GO_BACK: 'companyData',
          WAITING_LIST: 'waitingList',
        },
      },
      demoScheduled: {},
      blazeFreeTrialStarted: {},
      waitingList: {
        on: {
          GO_BACK: 'scheduleDemo',
        },
      },
    },
  })
